<template>
  <div class="container preventative-health">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="72" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="sourceofstress">
    </back-and-skip>
    <div class="row pt-3 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/preventative_health.svg" alt="catch-covid">
      </div>
    </div>
    <div class="row pt-3 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('preventativeHealth.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="precaution" value="vitamin-d" id="vitaminD" type="radio"/>
        <label class="option-label" for="vitaminD">{{ $t('preventativeHealth.vitaminD') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="precaution" value="zinc" id="zinc" type="radio"/>
        <label class="option-label" for="zinc">{{ $t('preventativeHealth.zinc') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="precaution" value="vitamin-c" id="vitaminC" type="radio"/>
        <label class="option-label" for="vitaminC">{{ $t('preventativeHealth.vitaminC') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="precaution" value="fitness" id="fitness" type="radio"/>
        <label class="option-label" for="fitness">{{ $t('preventativeHealth.fitness') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="precaution" value="healthy-diet" id="healthyDiet" type="radio"/>
        <label class="option-label" for="healthyDiet">{{ $t('preventativeHealth.healthyDiet') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="precaution" value="no" id="no" type="radio"/>
        <label class="option-label" for="no">{{ $t('preventativeHealth.no') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="precaution" value="other" id="other" type="radio"/>
        <label class="option-label" for="other">{{ $t('preventativeHealth.other') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <input v-model="other"
          placeholder="Other"
          type="text"
          class="form-control other"
          :style="{visibility: showOther? 'visible' : 'hidden'}">
      </div>
    </div>
    <div class="row pt-4 pb-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      precaution: '',
      other: '',
      showOther: false
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.selectOptionError')
        })
      } else {
        if (this.precaution === 'other' && this.other === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: this.$t('general.pleaseSpecifyError')
          })

          return
        }

        const answer = {
          key: 'taken_any_preventative_health_precautions',
          value: this.precaution === 'other' ? this.other : this.precaution
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'sourceofstress'
        })
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'preventativehealth')
  },
  watch: {
    precaution (val) {
      if (val === 'other') {
        this.showOther = true
      } else {
        this.showOther = false
      }
    }
  },
  validations: {
    precaution: {
      required
    }
  }
}
</script>

<style>
.preventative-health .img-question {
  width: 100%;
  height: 27vh;
}

.preventative-health .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.preventative-health .option-label {
  font-size: .85rem;
}

.preventative-health [type="radio"]:checked, [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.preventative-health [type="radio"]:checked + label, [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
}

.preventative-health [type="radio"]:checked + label:before, [type="radio"]:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}

.preventative-health [type="radio"]:checked + label:after, [type="radio"]:not(:checked) + label:after {
  content: '';
  width: 10px;
  height: 10px;
  background: #2bb1c4;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.preventative-health [type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.preventative-health [type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.preventative-health .other {
  width: 100%;
  height: 7vh;
  font-size: 12px;
  color: black;
}

.preventative-health .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .preventative-health .img-question {
    width: 100%;
    height: 17vh;
  }

  .preventative-health .title {
    font-size: 1rem;
  }

  .preventative-health .other {
    width: 100%;
    height: 6vh;
  }

  .preventative-health .next {
    min-height: 70px;
  }
}
</style>
